import Observable from '@/include/observable';

class BodyClasses {
  constructor() {
    this.register('cart-update', 'cart-update', true);
    this.register('cart-update', 'cart-update-complete', false);
    this.register('cart-updating', 'cart-updating', true);
    this.register('cart-updating', 'cart-updating-complete', false);
    this.registerTemp('cart-updated', 'cart-reloaded', 1500);
  }

  register(classname, observableAction, state) {
    Observable.subscribe(observableAction, () => {
      this.setClass(classname, state);
    });
  }

  registerTemp(classname, observableAction, timeout=1000) {
    Observable.subscribe(observableAction, () => {
      this.add(classname);
      setTimeout(() => {
        this.remove(classname);
      }, timeout);
    })
  }

  add(classname) {
    this.setClass(classname, true);
  }

  remove(classname) {
    this.setClass(classname, false);
  }

  setClass(classname, active) {
    document.body.classList[active ? 'add' : 'remove'](classname);
  }
}


export default new BodyClasses();